import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Divider from '@material-ui/core/Divider'
import DialogTitle from '@material-ui/core/DialogTitle'
import WorkPreferencesForm from '../../../WorkPreferences/Form'
import { StyledActions, StyledContent } from '../styles'
import { useOnboarding } from '../../../../../contexts/OnboardingContext'
import { DialogContentText } from '@material-ui/core'

export default function WorkPreferencesDialog(props) {
  const { open, handleClose, initialValues, setPropChange } = props
  const { formRef } = useOnboarding()

  const updateForm = async () => {
    await formRef.current.handleSubmit()
    setPropChange(true)
    handleClose()
  }
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>Work Preferences</DialogTitle>
      <DialogContentText>
        It’s time to let us know your availability and commitment goals, Getting you projects that you enjoy is
        beneficial for everyone. Let us know the types of projects you want and how you work.
      </DialogContentText>
      <StyledContent>
        <WorkPreferencesForm initialValues={initialValues} />
      </StyledContent>
      <Divider />
      <StyledActions>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={updateForm} color="primary">
          Save
        </Button>
      </StyledActions>
    </Dialog>
  )
}
